import { createSlice } from "@reduxjs/toolkit";

const initialState = { blockchain: ["All"], filterStatus: false };

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    // ordered: (state) => {
    //   state.numOfCakes--;
    // },
    updateBlockchain: (state, action) => {
      state.blockchain = action.payload;
    },
    updateFilterStatus: (state, action) => {
      state.filterStatus = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { updateBlockchain, updateFilterStatus } = filterSlice.actions;

// export const selectBlockchain = (state) => state.filter.blockchain; // не работает при вызове из useSelector(), таким образом: useSelector(selectBlockchain)
// export const selectFilterStatus = (state) => state.filter.filterStatus;
